import { createEffect, on } from 'solid-js'
import { DepthTexture, PerspectiveCamera } from 'three'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { getDeviceUserPreferenceHiDPI } from '../rx/shared/device/userPreference/getDeviceUserPreferenceHiDPI'
import { Engine } from './core/engine/Engine.type'
import { round } from './core/util/math/Math'
import onVisualViewportEvent from './onVisualViewportEvent'
import onWindowEvent from './onWindowEvent'
import { getEngineThreeMainCamera } from './three/fn/getSetEngineThreeMainCamera'
import { getEngineThreeMainRenderer } from './three/fn/getSetEngineThreeMainRenderer'
import useEffectComposer from './three/fn/useEffectComposer'

export default function bindViewCtxToWindowV2(
  engine: Engine,
  canvasElem: HTMLCanvasElement,
) {
  const vv = window.visualViewport
  let HiDPI = false
  const renderer = getEngineThreeMainRenderer(engine)
  const camera = getEngineThreeMainCamera(engine)

  const onResize = () => {
    // console.log('onResize')
    canvasElem.style.top = '0px'
    canvasElem.style.left = '0px'

    const dpr = window.devicePixelRatio || 1

    const wWidth = vv?.width ?? window.innerWidth
    const wHeight = vv?.height ?? window.innerHeight
    // console.log({ wWidth, wHeight })

    const renderW = round(HiDPI ? (wWidth * dpr) : wWidth)
    const renderH = round(HiDPI ? (wHeight * dpr) : wHeight)

    if (canvasElem.width !== renderW || canvasElem.height !== renderH) {
      canvasElem.width = renderW
      canvasElem.height = renderH
    }

    renderer.setSize(renderW, renderH)

    if (camera instanceof PerspectiveCamera) {
      camera.aspect = renderW / renderH
      camera.updateProjectionMatrix()
    }

    // note that the render sets this, so we must set it after.
    canvasElem.style.width = `${wWidth}px`
    canvasElem.style.height = `${wHeight}px`

    const composer = useEffectComposer(engine)
    const { domElement } = renderer
    const { width: domWidth, height: domHeight } = domElement
    // composer.setSize(window.wWidth, window.wHeight)
    // pixelateShaderEffect.uniforms.resolution.value.set(domWidth, domHeight)
    // depthSaturation.uniforms.resolution.value.set(domWidth, domHeight)
    composer.setSize(domWidth, domHeight)
    composer.passes.forEach((pass) => {
      if (pass instanceof ShaderPass) {
        const { resolution } = pass.uniforms
        if (resolution) {
          resolution.value.set(domWidth, domHeight)
        }
      }
    })
    composer.renderTarget1.depthTexture = new DepthTexture(domWidth, domHeight)
    composer.renderTarget2.depthTexture = new DepthTexture(domWidth, domHeight)
  }
  onWindowEvent('resize', onResize)
  onVisualViewportEvent('resize', onResize)

  createEffect(on(getDeviceUserPreferenceHiDPI, (newValue: boolean) => {
    // console.log('HiDPI', { oldValue: HiDPI, newValue })
    HiDPI = newValue
    onResize()
  }))

  // createMountedInverval(() => {
  //   HiDPI = !HiDPI
  //   onResize()
  // }, 1500)

  // manually trigger the effect of the resize listener
  onResize()
}
